import { createSelector } from 'reselect';

import type { State } from '@avalara/types/reducer-states';

const currentStepIndexSelector = (state: State) => state.progressBar.currentStep;
const stepsSelector = (state: State) => state.progressBar.steps;

export const currentStepLabelSelector: (state: State) => string = createSelector(
  [currentStepIndexSelector, stepsSelector],
  (currentStepIndex, steps) => steps[currentStepIndex]?.label,
);
